export default __webpack_public_path__ + "static/media/heimtierfutter.600x550.9a4a232c.jpg";